import { useTranslation } from 'react-i18next';

export function Splash({ error }: { error?: string }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg p-6 text-center">
      <img src="/logo.jpeg" alt="Lura" className="w-32 h-32 rounded-3xl mb-6 object-cover" />
      {error
        ? <p className="text-text-muted max-w-xs">{error}</p>
        : <p className="text-text-muted">{t('common.loading')}</p>
      }
    </div>
  );
}
